export const PROGRESS_MAX = 100;

export const INCREMENT_CHECK_POINT_1 = 50;

export const INCREMENT_CHECK_POINT_2 = 70;

export const INCREMENT_VALUE_1 = 12;

export const INCREMENT_VALUE_2 = 7;

export const INCREMENT_VALUE_3 = 5;

export const DELAY_AFTER_COMPLETION_MS = 500;
